<!-- <button *ngIf="!updatePass" mat-ripple class="o-backdrop__close-btn" (click)="close()">
  <fa-icon [icon]="['fas', 'times']"></fa-icon>
</button> -->

<div class="c-overlay"
     *ngIf="!passwordChange"
     [@fade]="formAnimationState"
     (@fade.done)="formAnimationDone()">

  <section *ngIf="!signUp"
           class="c-login">

    <h2 class="c-login__title">Login</h2>

    <form *ngIf="authForm"
          class="c-form c-login__form"
          method="post"
          [formGroup]="authForm"
          (ngSubmit)="submitAuthentication()">

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="login" type="email" placeholder="Email">

        <mat-error *ngIf="authForm.get('login').hasError('required')">
          Digite seu email de login
        </mat-error>

        <mat-error *ngIf="authForm.get('login').hasError('pattern')">
          O email digitado não é válido
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Senha</mat-label>
        <input matInput formControlName="senha" type="password" autocomplete="off" placeholder="Senha">

        <mat-error *ngIf="authForm.get('senha').hasError('required')">
          Digite sua senha
        </mat-error>
      </mat-form-field>


      <div class="c-form__control c-form__control--button">
        <button matRipple
                class="c-login__button c-button c-button--solid c-button--large t-primary"
                [disabled]="authForm.disabled">
          Entrar
        </button>

        <a href="#"
           class="c-overlay__pass-change-link"
           (click)="togglePasswordRequest($event)">Esqueci minha senha</a>
      </div>

    </form>

    <hr class="c-divider">

    <a href="#"
       class="c-button c-button--solid t-accent c-overlay__toggle"
       (click)="toggleSignUp($event)">Ainda não tenho uma conta</a>
  </section>

  <section *ngIf="signUp"
           class="c-signup">

    <h2 class="c-login__title">Cadastro de aluno</h2>

    <form *ngIf="signUpForm"
          class="c-form c-signup__form"
          method="post"
          [formGroup]="signUpForm"
          (ngSubmit)="submitSignUp()">

      <mat-form-field class="c-form__control c-form__control--name" appearance="fill">
        <mat-label>Nome completo</mat-label>
        <input matInput formControlName="nome" placeholder="Nome Completo">

        <mat-error *ngIf="signUpForm.get('nome').hasError('required')">
          Digite seu nome
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control c-form__control--school-year" appearance="fill">
        <mat-label>Ano Escolar</mat-label>

        <mat-select formControlName="anoEscolar" placeholder="Ano Escolar">
          <mat-option *ngFor="let option of schoolYearOptions"
                      [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="signUpForm.get('anoEscolar').hasError('required')">
          Selecione seu ano escolar
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Email">

        <mat-error *ngIf="signUpForm.get('email').hasError('required')">
          Digite seu email
        </mat-error>

        <mat-error *ngIf="signUpForm.get('email').hasError('pattern')">
          O email digitado não é válido
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Apelido</mat-label>
        <input matInput formControlName="apelido" placeholder="Apelido">

        <mat-error *ngIf="signUpForm.get('apelido').hasError('required')">
          Digite um apelido. É assim que vamos nos referir a você.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control c-form__control--uf" appearance="fill">
        <mat-label>Estado</mat-label>

        <mat-select formControlName="uf" placeholder="Estado">
          <mat-option *ngFor="let option of ufOptions"
                      [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="signUpForm.get('uf').hasError('required')">
          Selecione o estado onde você mora.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control c-form__control--city" appearance="fill">
        <mat-label>Cidade</mat-label>
        <input matInput formControlName="municipio" placeholder="Cidade">

        <mat-error *ngIf="signUpForm.get('municipio').hasError('required')">
          Digite o nome da cidade onde você mora.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Senha</mat-label>
        <input matInput formControlName="senha" type="password" autocomplete="off" placeholder="Senha">

        <mat-error *ngIf="signUpForm.get('senha').hasError('required')">
          Digite sua senha
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Confirmar senha</mat-label>
        <input matInput formControlName="confirmacaoSenha" type="password" autocomplete="off" placeholder="Confirmar senha">

        <mat-error *ngIf="signUpForm.get('confirmacaoSenha').hasError('required')">
          Confirme a sua senha.
        </mat-error>

        <mat-error *ngIf="signUpForm.get('confirmacaoSenha').hasError('noMatch')">
          As senhas digitadas devem ser idênticas.
        </mat-error>
      </mat-form-field>

      <div class="c-form__control c-form__control--button">
        <p class="u-margin-bottom-tiny">
          Ao clicar em cadastrar você concordará com os
          <a [redAnchor]="termsOfService">termos e condições</a>.
        </p>

        <button matRipple
                class="c-login__button c-button c-button--outline c-button--large t-primary"
                [disabled]="signUpForm.disabled">
          Cadastrar
        </button>
      </div>
    </form>

    <hr class="c-divider">

    <a href="#"
       class="c-button c-button--solid t-accent c-overlay__toggle"
       (click)="toggleSignUp($event)">Já tenho uma conta</a>
  </section>
</div>

<div class="c-overlay"
     *ngIf="passwordChange"
     [@fade]="formAnimationState"
     (@fade.done)="formAnimationDone()">

  <section class="c-request-password" *ngIf="(userId && token) || updatePass; else passRequestTemplate">

    <h2 class="c-request-password__title">Criar nova senha</h2>

    <p class="u-margin-bottom">
      Preencha os dados abaixo para criar uma nova senha
    </p>

    <form *ngIf="passResetForm"
          class="c-form c-request-password__form"
          method="post"
          [formGroup]="passResetForm"
          (ngSubmit)="submitPasswordReset()">

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Email">

        <mat-error *ngIf="passResetForm.get('email').hasError('required')">
          Digite seu email de login
        </mat-error>

        <mat-error *ngIf="passResetForm.get('email').hasError('pattern')">
          O email digitado não é válido
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Nova senha</mat-label>
        <input matInput formControlName="senha" type="password" autocomplete="off" placeholder="Nova senha">

        <mat-error *ngIf="passResetForm.get('senha').hasError('required')">
          Digite sua senha
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-form__control" appearance="fill">
        <mat-label>Confirmar senha</mat-label>
        <input matInput formControlName="confirmacaoSenha" type="password" autocomplete="off" placeholder="Confirmar senha">

        <mat-error *ngIf="passResetForm.get('confirmacaoSenha').hasError('required')">
          Confirme a sua senha.
        </mat-error>

        <mat-error *ngIf="passResetForm.get('confirmacaoSenha').hasError('noMatch')">
          As senhas digitadas devem ser idênticas.
        </mat-error>
      </mat-form-field>

      <div class="c-form__control c-form__control--button">
        <button matRipple
                class="c-login__button c-button c-button--solid c-button--large t-primary"
                [disabled]="passResetForm.disabled">
          Enviar
        </button>

        <a *ngIf="!updatePass"
           href="#" class="c-overlay__pass-change-link"
           (click)="togglePasswordRequest($event)">Ir para o login</a>
      </div>

    </form>
  </section>

  <ng-template #passRequestTemplate>
    <section class="c-request-password">

      <h2 class="c-request-password__title">Esqueci minha senha</h2>

      <p class="u-margin-bottom">
        Digite abaixo o seu email de login, e lhe enviaremos um link para
        que você possa alterar sua senha.
      </p>

      <form class="c-form c-request-password__form"
            method="post"
            [formGroup]="passRequestForm"
            (ngSubmit)="submitPasswordChangeRequest()">

        <mat-form-field class="c-form__control" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Email">

          <mat-error *ngIf="passRequestForm.get('email').hasError('required')">
            Digite seu email de login
          </mat-error>

          <mat-error *ngIf="passRequestForm.get('email').hasError('pattern')">
            O email digitado não é válido
          </mat-error>
        </mat-form-field>

        <div class="c-form__control c-form__control--button">
          <button matRipple
                  class="c-login__button c-button c-button--solid c-button--large t-primary"
                  [disabled]="passRequestForm.disabled">
            Enviar
          </button>

          <a href="#"
             class="c-overlay__pass-change-link"
             (click)="togglePasswordRequest($event)">Voltar</a>
        </div>

      </form>
    </section>
  </ng-template>
</div>
